import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/page/Home'
// import Simple from '@/components/page/Simple'
// import Meeting from '@/components/page/Meeting'
import Meeting2 from '@/components/page/Meeting2'
// import Section from '@/components/page/Section'
import Reports2 from '@/components/page/Reports2'
// import Persons from '@/components/page/Persons'
// import Cell from '@/components/page/Cell'
import Cells from '@/components/page/Cells'
import Persons from '@/components/page/Persons'
// import Multiplication from '@/components/page/Multiplication'
import Signin from '@/components/page/Signin'
import {
  t
} from '@/i18n'

Vue.use(Router)

export const routes = [{
    path: '/',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/signin',
    component: Signin,
    name: t('Sign in'),
    icon: 'lock_open',
    meta: {
      drawer: true
    }
  },
  // {
  //   path: '/signout',
  //   component: Signout,
  //   name: 'Sign Out',
  //   meta: { drawer: true, auth: true }
  // },
  // {
  //   path: '/persons',
  //   component: Persons,
  //   name: t('Persons'),
  //   icon: 'people',
  //   meta: { drawer: true, auth: true }
  // },
  {
    path: '/cells',
    component: Cells,
    name: t('Cells'),
    icon: 'home',
    meta: {
      drawer: true,
      auth: true,
      roles: ['A', 'P']
    }
  },
  // {
  //   path: '/simple/:goto',
  //   component: Simple,
  //   name: t('Simple'),
  //   icon: 'accessibility',
  //   props: true,
  //   meta: { drawer: true, auth: true, roles: ['A', 'P'] }
  // },
  // {
  //   path: '/cell',
  //   component: Cell,
  //   name: t('Composition'),
  //   icon: 'people',
  //   meta: { drawer: true, auth: true }
  // },
  // {
  //   path: '/meeting',
  //   component: Meeting,
  //   name: 'Stare Spotkania',
  //   icon: 'today',
  //   meta: {
  //     drawer: true,
  //     auth: true
  //   }
  // },
  {
    path: '/meeting2',
    component: Meeting2,
    name: t('Meetings'),
    icon: 'today',
    meta: {
      drawer: true,
      auth: true
    }
  },

  // {
  //   path: '/multiplication',
  //   component: Multiplication,
  //   name: t('Multiplication'),
  //   icon: 'call_split',
  //   meta: { drawer: true, auth: true }
  // }

  // {
  //   path: '/section',
  //   component: Section,
  //   name: t('Section'),
  //   icon: 'group_work',
  //   meta: { drawer: true, auth: true }
  // },

  {
    path: '/persons',
    component: Persons,
    name: t('Persons'),
    icon: 'people',
    meta: {
      drawer: true,
      auth: true,
      roles: ['A', 'P']
    }
  },

  {
    path: '/reports',
    component: Reports2,
    name: t('Reports'),
    icon: 'bar_chart',
    meta: {
      drawer: true,
      auth: true
    }
  }
]

export default new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history'
})
